(function () {
    console.log('CUSTOM CART --->');

    const targetNodeCart = document.getElementById('QuickCartDrawer');
    const targetNodeCart2 = document.querySelector('.template-cart');
    /* console.log('targetNodeCart', targetNodeCart); */
    // Options for the observer (which mutations to observe)
    let config = { attributes: true, childList: false, subtree: true };
    if (targetNodeCart2) {
        config = { attributes: true, childList: false, subtree: false };
    }

    // Callback function to execute when mutations are observed
    const callback = function(mutationsList, observerCart) {
        /* console.log(mutationsList, observerCart); */
        _manageCart();
    };

    // Create an observer instance linked to the callback function
    const observerCart = new MutationObserver(callback);
    if (targetNodeCart) observerCart.observe(targetNodeCart, config);
    if (targetNodeCart2) observerCart.observe(targetNodeCart2, config);


    function _manageCart() {
        // console.log('window.location.hostname', window.location.hostname);
        let ws_to_call = 'https://wh.specialmilano.com/availabilities/multiple/liveup';
        if (window.location.hostname.indexOf('sandbox') > -1) {
            ws_to_call = 'https://staging-wh.specialmilano.com/availabilities/multiple/liveup';
        }
        console.log('ws_to_call', ws_to_call);

        let line_item_data = document.querySelectorAll("[line-item-data]").length > 0 ? document.querySelectorAll("[line-item-data]") : document.querySelectorAll("[quick-line-item-data]");
        console.log('line_item_data', line_item_data);
        const cart_form = document.getElementById('cart');
        // console.log('cart_form', cart_form);

        const CART_DATA = [];
        for (var i = 0; i < line_item_data.length; i++) {
            CART_DATA.push({
                product_id: line_item_data[i].getAttribute('data-product-id'),
                variant_id: line_item_data[i].getAttribute('data-variant-id'),
                variant_options: line_item_data[i].getAttribute('data-variant-options'),
                // variant_options: JSON.parse(line_item_data[i].getAttribute('data-variant-options')),
                crossdomain: true
            });
        }
        console.log('CART_DATA', CART_DATA);

        cart_form.addEventListener('submit', function (event) {

            // event.preventDefault();
            axios.post(ws_to_call, {cart:CART_DATA})
            .then(function (response) {
                console.log(response);
                let this_form_error = document.querySelector('.form-error');
                if (this_form_error) this_form_error.classList.add('visually-hidden');
                // event start
            })
            .catch(function (error) {
                console.log(error);
                let toFocus = document.querySelector('[data-login-error]');
                let this_form_error = document.querySelector('.form-error');
                if (toFocus) toFocus.focus();
                if (this_form_error) this_form_error.classList.remove('visually-hidden');
                // event start
            });
        });
    }
})();